import React, { Component } from 'react'

export default class NumberFetch extends Component {

    state = {
        count: 0
    };

    componentDidMount(){
        this.interval = setInterval(() => {
            this.tick()
        },50);
    }

    getRndInteger(min, max) {
        return Math.floor(Math.random() * (max - min + 1) ) + min;
    }

    tick(){
        let number = this.getRndInteger(11, 99);
        this.setState({count: number})
    }

    render() {
        return (
            <span>{this.state.count}</span>
        )
    }

    componentWillUnmount(){
        clearInterval(this.interval);
    }
}
